var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSafetyLabel = function SvgSafetyLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#safety-label_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    d: "M11.124 5.594a1 1 0 0 1 1.752 0l6.97 12.674a1 1 0 0 1-.877 1.482H5.031a1 1 0 0 1-.876-1.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "m12 5.362 7.683 13.273H4.317zM2.552 17.615c-.785 1.357.194 3.061 1.765 3.061h15.366c1.57 0 2.55-1.704 1.765-3.06L13.765 4.341c-.786-1.357-2.745-1.357-3.53 0zm8.428-7.456v3.102c0 .561.459 1.02 1.02 1.02.561 0 1.02-.459 1.02-1.02V10.16c0-.562-.459-1.02-1.02-1.02-.561 0-1.02.458-1.02 1.02"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.047,
    height: 2.047,
    x: 10.977,
    y: 15.2,
    fill: "#21272C",
    rx: 1.023
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "safety-label_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.988v23.989H0z"
  })))));
};
export default SvgSafetyLabel;